import { render, staticRenderFns } from "./TuiTree.vue?vue&type=template&id=7c35fb32&"
import script from "./TuiTree.vue?vue&type=script&lang=ts&"
export * from "./TuiTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports